import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["image"];
  toggleLightbox(image) {
    if (!image.target) {
      let _image = image;
      if (image && !image.src) {
        _image = image.querySelector("img");
      }

      if (_image?.src !== this.imageTarget.src) {
        this.imageTarget.src = _image.src;
        this.imageTarget.alt = _image.alt;
      }
    }
    this.element.classList.toggle("hidden");
    document.body.classList.toggle("no-scroll");
  }
}
